import type { QueryClient, QueryKey } from '@tanstack/react-query';

const USER_AI_QUERY_ROOTS = new Set([
  'training-program',
  'training-program-week-review',
  'program-review',
]);

export function isUserAiQueryKey(queryKey: QueryKey, userId?: number): boolean {
  const [root, section, owner] = queryKey;
  if (root === 'ai') {
    if (section === 'status') return false;
    if (section !== 'personality' || userId === undefined) return true;
    return owner === userId || owner === 'anonymous';
  }
  return typeof root === 'string' && USER_AI_QUERY_ROOTS.has(root);
}

export function clearUserAiQueryCache(queryClient: QueryClient, userId?: number): void {
  const predicate = (query: { queryKey: QueryKey }) => isUserAiQueryKey(query.queryKey, userId);
  void queryClient.cancelQueries({ predicate });
  queryClient.removeQueries({ predicate });
}
